import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";
import type { ConnectorConnectionStatus } from "./ConnectorStatusBadge.types";

const statusColor: Record<ConnectorConnectionStatus, string> = {
  connected: rawColors.accent.green500,
  disconnected: rawColors.accent.red500,
  error: rawColors.accent.red500,
  not_connected: rawColors.text.mediumEmphasis,
};

const statusBorderColor: Record<ConnectorConnectionStatus, string> = {
  connected: rawColors.accent.green500,
  disconnected: rawColors.accent.red500,
  error: rawColors.accent.red500,
  not_connected: rawColors.stroke[200],
};

export const Badge = styled.span<{ $status: ConnectorConnectionStatus }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  padding: ${spacing[1]} ${spacing[2]};
  border-radius: 30px;
  border: 1px solid ${({ $status }) => statusBorderColor[$status]};
  background-color: transparent;
  color: ${({ $status }) => statusColor[$status]};
  white-space: nowrap;
  ${typographyMixin("caption", 3)}

  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: currentColor;
    flex-shrink: 0;
  }
`;
